import httpService from "./httpService";
import utils from "./utils";

export default {

  findById(id) {
    return httpService.get(`/hcCfgDriver/${id}`);
  },

  findAll(form, pageable) {
    let params = utils.merge(utils.initPageableParams(pageable), form);
    return httpService.get("/hcCfgDriver", {params: params});
  },

  findAll2(form, pageable) {
    let params = utils.merge(utils.initPageableParams(pageable), form);
    return httpService.get("/hcCfgDriver/findAll2", {params: params});
  },

  create(form) {
    return httpService.post("/hcCfgDriver", form);
  },

  update(id, form) {
    return httpService.put(`/hcCfgDriver/${id}`, form);
  },

  changeStatus(id) {
    return httpService.put(`/hcCfgDriver/${id}/changeStatus`);
  },

  delete(id) {
    return httpService.delete(`/hcCfgDriver/${id}`);
  },
}



// WEBPACK FOOTER //
// ./src/services/hcCfgDriverService.js